export const interviewQuestions = [
    {
      company: 'Google',
      jobTitle: 'Frontend Developer',
      jobDescription: 'As a Frontend Developer at Google, you will be responsible for developing user interfaces for Google products. You will work with a team of designers and backend developers to create seamless user experiences.',
      questions: [
        'Explain the difference between localStorage and sessionStorage.',
        'What are closures in JavaScript and how would you use them?',
        'Describe your approach to making a web application responsive.',
        'How do you optimize website performance?',
        'Explain how you would implement a feature that requires real-time updates.'
      ]
    },
    {
      company: 'Amazon',
      jobTitle: 'Full Stack Engineer',
      jobDescription: 'Amazon is looking for a Full Stack Engineer to join our team. You will be responsible for developing both frontend and backend components of our e-commerce platform. Strong knowledge of JavaScript frameworks and AWS services is required.',
      questions: [
        'Describe a complex technical problem you solved recently.',
        'How would you design a system that handles millions of transactions per hour?',
        'Explain your experience with microservices architecture.',
        'How do you ensure code quality in a fast-paced environment?',
        'Describe your approach to testing JavaScript code.'
      ]
    },
    {
      company: 'Microsoft',
      jobTitle: 'Software Engineer',
      jobDescription: 'As a Software Engineer at Microsoft, you will contribute to the development of Microsoft products and services. You will collaborate with cross-functional teams to design, develop, and maintain software solutions.',
      questions: [
        'Explain inheritance and polymorphism with examples.',
        'How would you optimize a database query that\'s running slowly?',
        'Describe your experience with agile development methodologies.',
        'How do you approach debugging a complex issue in production?',
        'What security considerations would you keep in mind when developing a web application?'
      ]
    },
    {
      company: 'Facebook',
      jobTitle: 'React Developer',
      jobDescription: 'Facebook is seeking a React Developer to join our team. You will be responsible for building and maintaining user interfaces for Facebook products using React. Deep understanding of React and its ecosystem is essential.',
      questions: [
        'Explain React\'s virtual DOM and its benefits.',
        'How do you manage state in a large React application?',
        'Describe the React component lifecycle methods.',
        'What are hooks in React and how do you use them?',
        'How would you optimize the performance of a React application?'
      ]
    },
    {
      company: 'Netflix',
      jobTitle: 'UI Engineer',
      jobDescription: 'Netflix is looking for a UI Engineer to join our team. You will be responsible for developing user interfaces for the Netflix streaming platform. Experience with responsive design and performance optimization is required.',
      questions: [
        'How would you implement a custom video player using JavaScript?',
        'Explain how you would handle internationalization in a web application.',
        'Describe your approach to accessibility in web development.',
        'How would you implement infinite scrolling in a web application?',
        'What strategies would you use to reduce loading times for a content-heavy page?'
      ]
    }
  ];